import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-case-details-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './case-details-nav.component.html'
})
export class CaseDetailsNavComponent {
  @Input() isMobileNav: boolean = false;
}
